module.exports = __webpack_public_path__ + "static/media/ANL.8b6ff825.svg";